import React from 'react'


export class Tab extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick = () => {
        this.props.onTabClick()
    }

    render() {
        const title = this.props.title
        return (
            <h4
                class={`
                    ps-cross-tab-select
                    cross-tab-select
                    ${this.props.selected && (`active`)}
                `}
                key={title}
                onClick={this.handleClick}
            >
                {title.toUpperCase()}
            </h4>
        )
    }
}


// WEBPACK FOOTER //
// app/helpers/Tabs/Tab.jsx